import { render, staticRenderFns } from "./RegisterThird.vue?vue&type=template&id=ad909ad8&scoped=true"
import script from "./RegisterThird.vue?vue&type=script&lang=js"
export * from "./RegisterThird.vue?vue&type=script&lang=js"
import style0 from "./RegisterThird.vue?vue&type=style&index=0&id=ad909ad8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad909ad8",
  null
  
)

export default component.exports